export const SPORTS = [
  {
    name: 'Formula Series',
    slug: 'formula-series',
    leagues: [
      {
        name: 'Formula 1',
        slug: 'formula-1',
        teams: [
          'McLaren',
          'Ferrari',
          'Mercedes',
          'Red Bull',
          'Aston Martin',
          'Alpine',
          'Williams',
          'Racing Bulls',
          'Haas',
          'Audi',
          'Cadillac',
        ],
      },
      {
        name: 'Formula 2',
        slug: 'formula-2',
        teams: [
          'Invicta Racing',
          'Campos Racing',
          'MP Motorsport',
          'DAMS Lucas Oil',
          'ART Grand Prix',
          'Prema Racing',
          'Rodin Motorsport',
          'Hitech TGR',
          'Trident',
          'Van Amersfoort Racing',
          'AIX Racing',
          'PHM AIX Racing',
        ],
      },
      {
        name: 'Formula 3',
        slug: 'formula-3',
        teams: [
          'Prema Racing',
          'Trident',
          'ART Grand Prix',
          'Campos Racing',
          'Hitech Pulse-Eight',
          'MP Motorsport',
          'Rodin Motorsport',
          'Van Amersfoort Racing',
          'DAMS Lucas Oil',
          'AIX Racing',
          'Jenzer Motorsport',
        ],
      },
      {
        name: 'Formula E',
        slug: 'formula-e',
        teams: [
          'Jaguar TCS Racing',
          'TAG Heuer Porsche Formula E',
          'Nissan Formula E Team',
          'Mahindra Racing',
          'Envision Racing',
          'Andretti Formula E',
          'DS Penske',
          'Maserati MSG Racing',
          'NEOM McLaren Formula E',
          'ABT CUPRA Formula E Team',
          'ERT Formula E Team',
          'Cupra Kiro',
        ],
      },
      {
        name: 'IndyCar',
        slug: 'indycar',
        teams: [
          'Team Penske',
          'Chip Ganassi Racing',
          'Andretti Global',
          'Arrow McLaren',
          'Rahal Letterman Lanigan Racing',
          'Meyer Shank Racing',
          'Ed Carpenter Racing',
          'Juncos Hollinger Racing',
          'Dale Coyne Racing',
          'AJ Foyt Racing',
        ],
      },
      {
        name: 'Super Formula',
        slug: 'super-formula',
        teams: [
          'Team Mugen',
          'TOMS',
          'Docomo Team Dandelion Racing',
          'Kondo Racing',
          'Nakajima Racing',
          'Team Impul',
          'Inging',
          'Cerumo / Inging',
          'Vertex Partners Cerumo Inging',
        ],
      },
    ],
    teams: [],
  },
  {
    name: 'Football',
    slug: 'football',
    leagues: [
      {
        name: 'Premier League',
        slug: 'premier-league',
        teams: [
          'Arsenal',
          'Aston Villa',
          'AFC Bournemouth',
          'Brentford',
          'Brighton & Hove Albion',
          'Chelsea',
          'Coventry City',
          'Crystal Palace',
          'Everton',
          'Fulham',
          'Hull City',
          'Ipswich Town',
          'Leeds United',
          'Liverpool',
          'Manchester City',
          'Manchester United',
          'Newcastle United',
          'Nottingham Forest',
          'Sunderland',
          'Tottenham Hotspur',
        ],
      },
      {
        name: 'La Liga',
        slug: 'la-liga',
        teams: [
          'Alavés',
          'Athletic Bilbao',
          'Atlético Madrid',
          'Barcelona',
          'Real Betis',
          'Celta Vigo',
          'Deportivo La Coruña',
          'Elche',
          'Espanyol',
          'Getafe',
          'Levante',
          'Málaga',
          'Osasuna',
          'Racing Santander',
          'Rayo Vallecano',
          'Real Madrid',
          'Real Sociedad',
          'Sevilla',
          'Valencia',
          'Villarreal',
        ],
      },
      {
        name: 'Serie A',
        slug: 'serie-a',
        teams: [
          'Atalanta',
          'Bologna',
          'Cagliari',
          'Como',
          'Fiorentina',
          'Frosinone',
          'Genoa',
          'Inter Milan',
          'Juventus',
          'Lazio',
          'Lecce',
          'AC Milan',
          'Monza',
          'Napoli',
          'Parma',
          'Roma',
          'Sassuolo',
          'Torino',
          'Udinese',
          'Venezia',
        ],
      },
      {
        name: 'Bundesliga',
        slug: 'bundesliga',
        teams: [
          'FC Augsburg',
          '1. FC Union Berlin',
          'Werder Bremen',
          'Borussia Dortmund',
          'SV Elversberg',
          'Eintracht Frankfurt',
          'SC Freiburg',
          'Hamburger SV',
          'TSG Hoffenheim',
          '1. FC Köln',
          'RB Leipzig',
          'Bayer Leverkusen',
          '1. FSV Mainz 05',
          'Borussia Mönchengladbach',
          'Bayern Munich',
          'SC Paderborn 07',
          'FC Schalke 04',
          'VfB Stuttgart',
        ],
      },
      {
        name: 'Ligue 1',
        slug: 'ligue-1',
        teams: [
          'Angers',
          'Auxerre',
          'Stade Brestois',
          'Le Havre',
          'Le Mans',
          'RC Lens',
          'LOSC Lille',
          'FC Lorient',
          'Olympique Lyonnais',
          'Olympique de Marseille',
          'AS Monaco',
          'OGC Nice',
          'Paris FC',
          'Paris Saint-Germain',
          'Stade Rennais',
          'Strasbourg',
          'Toulouse',
          'ES Troyes',
        ],
      },
    ],
    teams: [],
  },
  {
    name: 'Basketball',
    slug: 'basketball',
    leagues: [
      {
        name: 'NBA',
        slug: 'nba',
        teams: [
          // Eastern Conference
          'Atlanta Hawks',
          'Boston Celtics',
          'Brooklyn Nets',
          'Charlotte Hornets',
          'Chicago Bulls',
          'Cleveland Cavaliers',
          'Detroit Pistons',
          'Indiana Pacers',
          'Miami Heat',
          'Milwaukee Bucks',
          'New York Knicks',
          'Orlando Magic',
          'Philadelphia 76ers',
          'Toronto Raptors',
          'Washington Wizards',
          // Western Conference
          'Dallas Mavericks',
          'Denver Nuggets',
          'Golden State Warriors',
          'Houston Rockets',
          'Los Angeles Clippers',
          'Los Angeles Lakers',
          'Memphis Grizzlies',
          'Minnesota Timberwolves',
          'New Orleans Pelicans',
          'Oklahoma City Thunder',
          'Phoenix Suns',
          'Portland Trail Blazers',
          'Sacramento Kings',
          'San Antonio Spurs',
          'Utah Jazz',
        ],
      },
      {
        name: 'EuroLeague',
        slug: 'euroleague',
        teams: [
          'Real Madrid',
          'FC Barcelona',
          'Panathinaikos',
          'Olympiacos',
          'Fenerbahçe Beko',
          'Anadolu Efes',
          'Žalgiris Kaunas',
          'Maccabi Tel Aviv',
          'AS Monaco',
          'Baskonia',
          'Partizan Mozzart Bet',
          'Crvena Zvezda',
          'FC Bayern Munich',
          'ALBA Berlin',
          'Virtus Bologna',
          'EA7 Olimpia Milano',
          'Paris Basketball',
          'ASVEL Villeurbanne',
          'Valencia Basket',
          'Dubai Basketball',
        ],
      },
    ],
    teams: [],
  },
  {
    name: 'Baseball',
    slug: 'baseball',
    leagues: [
      {
        name: 'MLB',
        slug: 'mlb',
        teams: [
          'Baltimore Orioles',
          'Boston Red Sox',
          'New York Yankees',
          'Tampa Bay Rays',
          'Toronto Blue Jays',
          'Chicago White Sox',
          'Cleveland Guardians',
          'Detroit Tigers',
          'Kansas City Royals',
          'Minnesota Twins',
          'Houston Astros',
          'Los Angeles Angels',
          'Athletics',
          'Seattle Mariners',
          'Texas Rangers',
          'Atlanta Braves',
          'Miami Marlins',
          'New York Mets',
          'Philadelphia Phillies',
          'Washington Nationals',
          'Chicago Cubs',
          'Cincinnati Reds',
          'Milwaukee Brewers',
          'Pittsburgh Pirates',
          'St. Louis Cardinals',
          'Arizona Diamondbacks',
          'Colorado Rockies',
          'Los Angeles Dodgers',
          'San Diego Padres',
          'San Francisco Giants',
        ],
      },
    ],
    teams: [],
  },
  {
    name: 'Volleyball',
    slug: 'volleyball',
    leagues: [
      {
        name: 'FIVB Nations League',
        slug: 'fivb-nations-league',
        teams: [
          'Poland',
          'Italy',
          'Brazil',
          'United States',
          'France',
          'Japan',
          'Serbia',
          'Argentina',
          'Canada',
          'Germany',
          'Netherlands',
          'Slovenia',
          'Cuba',
          'Iran',
          'Turkey',
          'China',
          'Bulgaria',
          'Belgium',
        ],
      },
    ],
    teams: [],
  },
  {
    name: 'Cricket',
    slug: 'cricket',
    leagues: [
      {
        name: 'IPL',
        slug: 'ipl',
        teams: [
          'Chennai Super Kings',
          'Mumbai Indians',
          'Royal Challengers Bengaluru',
          'Kolkata Knight Riders',
          'Sunrisers Hyderabad',
          'Delhi Capitals',
          'Punjab Kings',
          'Rajasthan Royals',
          'Gujarat Titans',
          'Lucknow Super Giants',
        ],
      },
      {
        name: 'ICC Full Members',
        slug: 'icc-full-members',
        teams: [
          'Afghanistan',
          'Australia',
          'Bangladesh',
          'England',
          'India',
          'Ireland',
          'New Zealand',
          'Pakistan',
          'South Africa',
          'Sri Lanka',
          'West Indies',
          'Zimbabwe',
        ],
      },
    ],
    teams: [],
  },
  {
    name: 'Rugby',
    slug: 'rugby',
    leagues: [
      {
        name: 'Six Nations',
        slug: 'six-nations',
        teams: ['England', 'France', 'Ireland', 'Italy', 'Scotland', 'Wales'],
      },
      {
        name: 'The Rugby Championship',
        slug: 'rugby-championship',
        teams: ['Argentina', 'Australia', 'New Zealand', 'South Africa'],
      },
    ],
    teams: [],
  },
];

export function sportToSlug(name) {
  return String(name || '')
    .toLowerCase()
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

/** Legacy F1 routes / product fields map onto Formula Series. */
const SPORT_ALIASES = {
  f1: 'formula-series',
  'formula-1': 'formula-series',
  formula1: 'formula-series',
  'formula one': 'formula-series',
  'formula series': 'formula-series',
};

export function getSportBySlug(slug) {
  if (!slug) return null;
  const normalized = slug.toLowerCase();
  const aliased = SPORT_ALIASES[normalized] || normalized;
  return (
    SPORTS.find(sport => sport.slug === aliased) ||
    SPORTS.find(sport => sport.name.toLowerCase() === normalized.replace(/-/g, ' ')) ||
    null
  );
}

export function getSportByName(name) {
  if (!name) return null;
  const normalized = name.toLowerCase().trim();
  if (SPORT_ALIASES[normalized] || SPORT_ALIASES[sportToSlug(normalized)]) {
    return getSportBySlug(SPORT_ALIASES[normalized] || SPORT_ALIASES[sportToSlug(normalized)]);
  }
  return (
    SPORTS.find(sport => sport.name.toLowerCase() === normalized) ||
    SPORTS.find(sport => sport.slug === sportToSlug(name)) ||
    null
  );
}

export function getProductSport(product) {
  return product.sport || product.category || '';
}

export function productBelongsToSport(product, sport) {
  if (!sport) return false;
  const productSport = getProductSport(product).toLowerCase().trim();
  if (!productSport) return false;

  if (
    productSport === sport.name.toLowerCase() ||
    productSport === sport.slug.toLowerCase()
  ) {
    return true;
  }

  // Legacy products tagged as F1 belong under Formula Series
  if (sport.slug === 'formula-series') {
    return (
      productSport === 'f1' ||
      productSport === 'formula 1' ||
      productSport === 'formula-1' ||
      productSport === 'formula one'
    );
  }

  return false;
}

export function getProductTeam(product) {
  if (product?.team) return product.team;
  // Legacy stores used products.brand as the team. Don't treat a licensed brand as a team.
  if (product?.brand_slug) return '';
  return product?.brand || '';
}

export function getProductLeague(product) {
  return product.league || '';
}

function normalizeLabel(value) {
  return String(value || '')
    .toLowerCase()
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

/** Common product tags → canonical team names in SPORTS. */
const TEAM_ALIASES = {
  'la clippers': 'Los Angeles Clippers',
  'clippers': 'Los Angeles Clippers',
  'lakers': 'Los Angeles Lakers',
  'la lakers': 'Los Angeles Lakers',
};

function canonicalizeTeamLabel(value) {
  const normalized = normalizeLabel(value);
  return TEAM_ALIASES[normalized] || value;
}

function escapeRegExp(value) {
  return String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/** Whole-token containment so "mclaren" matches inside "arrow mclaren", not "mclarenship". */
function hasTokenContainment(longer, shorter) {
  if (!longer || !shorter || shorter.length < 4) return false;
  return new RegExp(`(?:^|\\s)${escapeRegExp(shorter)}(?:$|\\s)`).test(longer);
}

export function getTeamsForSport(sport) {
  if (!sport) return [];
  return [
    ...(sport.teams || []),
    ...(sport.leagues || []).flatMap(league => league.teams || []),
  ];
}

/**
 * Score how well a product team label matches a known team.
 * Exact wins; then product extending known ("Arrow McLaren SP" → Arrow McLaren);
 * then short product inside longer known ("Lakers" → Los Angeles Lakers) — weaker,
 * so "McLaren" prefers exact McLaren over Arrow McLaren when both are candidates.
 */
function scoreTeamMatch(productNorm, knownNorm) {
  if (!productNorm || !knownNorm) return 0;
  if (productNorm === knownNorm) return 10000 + knownNorm.length;

  if (hasTokenContainment(productNorm, knownNorm)) {
    return 5000 + knownNorm.length;
  }

  if (hasTokenContainment(knownNorm, productNorm)) {
    return 1000 + productNorm.length;
  }

  return 0;
}

/** Pick the single best known team for a product label (disambiguates McLaren vs Arrow McLaren). */
export function resolveBestTeamMatch(productTeam, knownTeams) {
  const canonical = canonicalizeTeamLabel(productTeam);
  const productNorm = normalizeLabel(canonical);
  if (!productNorm || !knownTeams?.length) return null;

  let best = null;
  let bestScore = 0;

  knownTeams.forEach(team => {
    const score = scoreTeamMatch(productNorm, normalizeLabel(team));
    if (score > bestScore) {
      bestScore = score;
      best = team;
    }
  });

  return best;
}

/** True if product team/brand matches a known team name (handles accents & short names). */
export function teamNamesMatch(productTeam, knownTeam, knownTeams = null) {
  const a = normalizeLabel(productTeam);
  const b = normalizeLabel(knownTeam);
  if (!a || !b) return false;

  if (knownTeams?.length) {
    const best = resolveBestTeamMatch(productTeam, knownTeams);
    return normalizeLabel(best) === b;
  }

  if (a === b) return true;
  // Without a team catalog, only allow the product to extend the known name
  // (not the reverse) so "McLaren" does not claim "Arrow McLaren".
  return hasTokenContainment(a, b);
}

export function productBelongsToLeague(product, league, sport = null) {
  if (!league) return false;

  const productLeague = normalizeLabel(getProductLeague(product));
  if (productLeague) {
    if (
      productLeague === normalizeLabel(league.name) ||
      productLeague === normalizeLabel(league.slug) ||
      sportToSlug(productLeague) === league.slug
    ) {
      return true;
    }
    // Explicit league that isn't this one — don't leak via fuzzy team names.
    return false;
  }

  const productTeam = getProductTeam(product);
  if (!productTeam) return false;

  const catalog = sport ? getTeamsForSport(sport) : league.teams || [];
  const best = resolveBestTeamMatch(productTeam, catalog);
  if (!best) return false;

  return (league.teams || []).some(team => normalizeLabel(team) === normalizeLabel(best));
}

export function productBelongsToTeam(product, teamName, sport = null) {
  if (!teamName) return false;
  const productTeam = getProductTeam(product);
  if (!productTeam) return false;

  if (sport) {
    const best = resolveBestTeamMatch(productTeam, getTeamsForSport(sport));
    return normalizeLabel(best) === normalizeLabel(teamName);
  }

  return teamNamesMatch(productTeam, teamName);
}

export function groupProductsByTeam(products) {
  const groups = new Map();

  products.forEach(product => {
    const team = getProductTeam(product) || 'Other';
    if (!groups.has(team)) {
      groups.set(team, []);
    }
    groups.get(team).push(product);
  });

  return Array.from(groups.entries()).map(([team, items]) => ({ team, products: items }));
}

export function teamToSlug(name) {
  return sportToSlug(name);
}

export function findTeamBySlug(sport, slug) {
  if (!sport || !slug) return null;
  const normalized = slug.toLowerCase();
  const allTeams = [
    ...(sport.teams || []),
    ...(sport.leagues || []).flatMap(league => league.teams || []),
  ];
  return allTeams.find(team => teamToSlug(team) === normalized) || null;
}

export function findLeagueBySlug(sport, slug) {
  if (!sport || !slug) return null;
  return (sport.leagues || []).find(league => league.slug === slug.toLowerCase()) || null;
}
